import { memo } from 'react';
import { GlobalConfigContainer } from './globalConfig/containers/GlobalConfigContainer';
import { ProfileConfigContainer } from './profileConfig/containers/ProfileConfigContainer';
import { CreateJobPostConfigContainer } from './createJobPostConfig/containers/CreateJobPostConfigContainer';

// Here will be some components with global state
export const Containers = memo(() => {
  return (
    <>
      <GlobalConfigContainer />
      <ProfileConfigContainer />
      <CreateJobPostConfigContainer />
    </>
  );
});
